import $ from 'jquery';

import trapFocus from '../Services/trapFocus';
import responsive from '../Services/responsive';
import popinWidget from '../Widgets/ui/popin';

/**
 * @param {HTMLElement} element
 * @param {HTMLElement} popinElement
 */
function getPopinElementToShow(element, popinElement) {
  var partSelectors = $(element).data('popin-shownparts');

  return $(partSelectors, popinElement);
}

export function closePopin() {
  $.fancybox.close();
}

export function repositionPopin() {
  $.fancybox.reposition();
}

/**
 * @param {(String|HTMLElement)} selector
 * @param {Object} [_options]
 * @param {HTMLElement} [_options.activatorElement]
 * @param {Boolean} [_options.modal]
 */
export function openPopin(selector, _options) {
  var $elem = $(selector),
    defaultOptions = {
      modal: false,
      activatorElement: null,
    },
    options = $.extend({}, defaultOptions, _options);

  // make sure the element has a popin className
  if ($elem.hasClass('popin')) {
    $elem.find('.js-popin-hidden-content').hide();

    if (options.activatorElement) {
      getPopinElementToShow(options.activatorElement, $elem).show();
    }

    $('body').css('overflow-y', 'hidden');

    // popin the thing
    $.fancybox($elem, {
      openEffect: 'none',
      closeEffect: 'none',
      padding: 0,
      margin: responsive.getCurrent() === responsive.SCREEN_WIDTH_SMALL ? 4 : 20,
      title: $elem.data('popin-title'),
      modal: options.modal,

      afterClose: function () {
        $elem.attr('aria-hidden', true);
        trapFocus.untrap($elem);
        if (options.activatorElement) {
          $(options.activatorElement).focus();
        }

        $('body').css('overflow-y', 'initial');
      },

      afterLoad: function () {
        var $closeButtons = $('.js-close-button', this.content);

        if (options.modal) {
          $closeButtons.remove();
        } else {
          $closeButtons.on('click', function (event) {
            var href = $(this).attr('href');

            // permit to attach links to closing buttons,
            // to close popin AND go to an url
            if (!href || href === '#') {
              event.preventDefault();
            }

            $.fancybox.close();
          });
        }
      },

      // give focus to the fancy window (to handle shortcuts)
      afterShow: function () {
        $elem.attr('aria-hidden', false);
        if ($elem.is(':data("OC-popin")')) {
          $elem.popin('resize');
        } else {
          popinWidget.create($elem);
        }
        trapFocus.trap($elem);

        if (options.modal) {
          $('input, a', this.content).first().focus();
        }
      },
    });
  }
}

export function openLoginPopin() {
  openPopin('#popin-log-in');
}

export function openRegisterPopin() {
  openPopin('#popin-sign-in');
}
